module.exports = __webpack_public_path__ + "img/bow-text.41d9a5b3.svg";